// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8941ac7","239":"de0f8285","667":"bd765c98"}[chunkId] + ".chunk.js";
};